"use client";
export { SliderArrow as default } from "../../../_Builtin/Slider";
